/* eslint-disable */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from '../../../App';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styles        from '../../form/merchant-recap/merchant-recap.module.css';
import payment_recap from '../../form/payment-recap/payment-recap.module.css';
import checkbox      from '../../form/merchant-recap/checkbox.module.css';
import UpsellCards   from '../../shared/UpsellCards/UpsellCards';
import { GESTION_UPSELLS } from '../../../config/upsells';
import dataLayerPush from '../../../utils/data-layer';

function GestionMerchantRecap() {
    const { company, handleChange } = useContext(UserContext);
    const navigate = useNavigate();

    const total_ht         = useRef(null);
    const total_tva        = useRef(null);
    const total_ttc        = useRef(null);
    const total_button_txt = useRef(null);
    const cgv_checkbox     = useRef(null);
    const checkout_cta     = useRef(null);

    const companyName = company.form.pappers?.denomination || company.form.dealname || 'votre entreprise';
    const packName    = company.form.gestion_pack || company.form.legal_pack || 'Premium & Réussite';
    const monthlyHT   = parseFloat(company.shoppingCart?.accounting) || 0;

    // ── État local des upsells ────────────────────────────────────────────────
    const [upsellQty, setUpsellQty] = useState(() => {
        const init = {};
        GESTION_UPSELLS.forEach(u => {
            if (u.type === 'toggle') {
                init[u.key] = !!company.shoppingCart?.[u.key];
            } else {
                const stored = parseFloat(company.shoppingCart?.[u.key]) || 0;
                init[u.key] = u.price > 0 ? Math.round(stored / u.price) : 0;
            }
        });
        return init;
    });

    // ── Totaux ────────────────────────────────────────────────────────────────
    const upsellTotal = GESTION_UPSELLS.reduce((sum, u) => {
        if (u.type === 'toggle') return sum + (upsellQty[u.key] ? u.price : 0);
        return sum + upsellQty[u.key] * u.price;
    }, 0);

    const grandTotalHT = monthlyHT + upsellTotal;

    useEffect(() => {
        const tva      = grandTotalHT * 0.2;
        const totalTTC = grandTotalHT * 1.2;

        if (total_ht.current)         total_ht.current.innerHTML         = grandTotalHT.toFixed(2).replace('.', ',') + '\u00a0€';
        if (total_tva.current)        total_tva.current.innerHTML        = tva.toFixed(2).replace('.', ',') + '\u00a0€';
        if (total_ttc.current)        total_ttc.current.innerHTML        = parseFloat(totalTTC.toFixed(2)).toLocaleString('fr-FR') + '\u00a0€';
        if (total_button_txt.current) total_button_txt.current.innerHTML = 'Configurer mon prélèvement SEPA →';

        dataLayerPush({ event: 'view_cart' });
    }, [grandTotalHT]);

    // ── CGV ───────────────────────────────────────────────────────────────────
    const cgv_checkbox_update = (event) => {
        if (event.target.checked) {
            checkout_cta.current.classList.remove(payment_recap.unselectable);
        } else {
            checkout_cta.current.classList.add(payment_recap.unselectable);
        }
    };

    const handleClickForDataLayer = () => {
        dataLayerPush({ event: 'initiate_checkout', price: (grandTotalHT * 1.2).toFixed(2) });
    };

    // ── Features par pack ─────────────────────────────────────────────────────
    const featuresByPack = {
        'Premium & Réussite': [
            { text: 'Bilan, liasse fiscale et déclaration de TVA',                    included: true  },
            { text: 'Télétransmission aux impôts',                                    included: true  },
            { text: "Comptable dédié spécialisé dans votre secteur d'activité",       included: true  },
            { text: 'Disponible par appel, visioconférence et mail 5j/7',             included: true  },
            { text: 'Conseils illimités et optimisations fiscales',                   included: true  },
            { text: 'Logiciel comptable + tableaux de bord en temps réel',            included: true  },
            { text: 'Logiciel de facturation illimité',                               included: true  },
            { text: 'Connexion avec plus de 500 API bancaires',                       included: true  },
            { text: 'Catégorisation automatisée des transactions',                    included: true  },
            { text: "Certification des comptes par l'Expert-Comptable",               included: true  },
            { text: 'Assistance en cas de contrôle fiscal',                           included: true  },
        ],
        'Standard': [
            { text: 'Bilan, liasse fiscale et déclaration de TVA',                    included: true  },
            { text: 'Télétransmission aux impôts',                                    included: true  },
            { text: "Comptable dédié spécialisé dans votre secteur d'activité",       included: true  },
            { text: 'Disponible par appel, visioconférence et mail 5j/7',             included: true  },
            { text: 'Logiciel comptable + tableaux de bord en temps réel',            included: true  },
            { text: 'Logiciel de facturation illimité',                               included: true  },
            { text: 'Catégorisation automatisée des transactions',                    included: true  },
            { text: "Certification des comptes par l'Expert-Comptable",               included: true  },
            { text: 'Conseils illimités et optimisations fiscales',                   included: false },
            { text: 'Connexion avec plus de 500 API bancaires',                       included: false },
            { text: 'Assistance en cas de contrôle fiscal',                           included: false },
        ],
        'Débutant & Seul': [
            { text: 'Bilan, liasse fiscale et déclaration de TVA',                    included: true  },
            { text: 'Télétransmission aux impôts',                                    included: true  },
            { text: "Comptable dédié avec accompagnement",                            included: true  },
            { text: 'Logiciel comptable + tableaux de bord en temps réel',            included: true  },
            { text: 'Disponible par mail uniquement',                                 included: false },
            { text: 'Conseils illimités et optimisations fiscales',                   included: false },
            { text: 'Logiciel de facturation illimité',                               included: false },
            { text: 'Connexion avec plus de 500 API bancaires',                       included: false },
            { text: 'Catégorisation automatisée des transactions',                    included: false },
            { text: 'Assistance en cas de contrôle fiscal',                           included: false },
        ],
    };

    const features = featuresByPack[packName] || featuresByPack['Premium & Réussite'];

    return (
        <div className="self-step main-22">
            <div className="global">
                <div className="questions">Récapitulatif de votre commande</div>
                <div className={styles.subtitle}>
                    Dernière étape&nbsp;! Suite à la mise en place du prélèvement, vous accèderez aux services et serez mis en relation avec votre expert dédié.
                </div>

                <div className={styles['merchant-recap']}>
                    {/* ── Colonne gauche ── */}
                    <div className={styles.lines}>

                        {/* Pack comptabilité */}
                        <div className={styles['line-items']}>
                            <div className={styles.title}>
                                <div className={styles.name}>
                                    Abonnement comptabilité pour <span className={styles.legal_name}>{companyName}</span>
                                </div>
                            </div>

                            <div className={styles['line-item']}>
                                <div className={styles['line-information']}>
                                    <div className={styles.name}>🏅 Pack {packName}</div>
                                    <div className={styles.pricing}>
                                        {monthlyHT.toLocaleString('fr-FR')}&nbsp;€ <span className={styles.exhibitor}>HT / mois</span>
                                    </div>
                                </div>
                                <ul>
                                    {features.map((f, i) => (
                                        <li key={i} style={{ backgroundImage: f.included ? "url('/icon/big_check.svg')" : "url('/icon/big_cross.svg')" }}>
                                            {f.text}
                                        </li>
                                    ))}
                                </ul>
                                {/* <div className={styles.payLater}>
                                    Puis dans 15 jours : {monthlyHT.toLocaleString('fr-FR')}&nbsp;€ <span className={styles.exhibitor}>HT</span> / mois
                                </div> */}
                            </div>
                        </div>

                        {/* ── Upsells optionnels ── */}
                        <UpsellCards config={GESTION_UPSELLS} upsellQty={upsellQty} setUpsellQty={setUpsellQty} />
                    </div>

                    {/* ── Colonne droite : récap prix ── */}
                    <div className={payment_recap.complementary}>
                        <div className={payment_recap.pricing}>
                            <div className={`${payment_recap.title} ${payment_recap.title_recap_1}`}>Récapitulatif</div>

                            {/* Pack comptabilité */}
                            <div className={payment_recap.ht_total} style={{ marginBottom: '4px' }}>
                                <div className={payment_recap.label} style={{ fontSize: '9pt' }}>Pack {packName} :</div>
                                <div className={payment_recap.price} style={{ fontSize: '9pt' }}>
                                    {monthlyHT.toLocaleString('fr-FR')}&nbsp;€ HT
                                </div>
                            </div>

                            {/* Options sélectionnées */}
                            {GESTION_UPSELLS.map(upsell => {
                                const qty      = upsellQty[upsell.key];
                                const selected = upsell.type === 'toggle' ? !!qty : qty > 0;
                                if (!selected) return null;
                                const linePrice = upsell.type === 'toggle' ? upsell.price : qty * upsell.price;
                                return (
                                    <div key={upsell.key} className={payment_recap.ht_total} style={{ marginBottom: '4px' }}>
                                        <div className={payment_recap.label} style={{ fontSize: '9pt' }}>
                                            {upsell.label}{upsell.type === 'quantity' && qty > 1 ? ` ×${qty}` : ''} :
                                        </div>
                                        <div className={payment_recap.price} style={{ fontSize: '9pt' }}>
                                            {linePrice.toLocaleString('fr-FR')}&nbsp;€
                                        </div>
                                    </div>
                                );
                            })}

                            <div style={{ borderTop: '1px solid #eee', margin: '10px 0 6px' }} />

                            <div className={payment_recap.ht_total}>
                                <div className={payment_recap.label}>Sous-total HT :</div>
                                <div className={payment_recap.price} ref={total_ht}></div>
                            </div>
                            <div className={payment_recap.tva_total}>
                                <div className={payment_recap.label}>
                                    TVA :
                                    <div className="question overlay">
                                        ?<span className="answer"><span style={{ textDecoration: 'underline' }}>Votre société pourra récupérer la TVA facturée sur l'abonnement.</span></span>
                                    </div>
                                </div>
                                <div className={payment_recap.price} ref={total_tva}></div>
                            </div>
                            <div className={payment_recap.total}>
                                <div className={payment_recap.label}>Total TTC :</div>
                                <div className={payment_recap.price} ref={total_ttc}></div>
                            </div>

                            {/* Checkbox CGV */}
                            <div className={payment_recap.conditions}>
                                <div className={payment_recap.description}>
                                    <label className={checkbox.label}>
                                        <input
                                            type='checkbox'
                                            id='cgv_checkbox'
                                            ref={cgv_checkbox}
                                            onChange={cgv_checkbox_update}
                                        />
                                        <span></span>
                                    </label>
                                    {' '}
                                    <label htmlFor='cgv_checkbox'>
                                        J&apos;accepte les{' '}
                                        <a href="https://www.comptastar.fr/conditions-generales" className={payment_recap.cgv_link} target='_blank' rel="noreferrer">
                                            conditions générales
                                        </a>
                                        {' '}et la{' '}
                                        <a href="https://www.comptastar.fr/conditions-generales" className={payment_recap.cgv_link} target='_blank' rel="noreferrer">
                                            charte de vie privée
                                        </a>
                                    </label>
                                </div>
                            </div>

                            <Link
                                onClick={handleClickForDataLayer}
                                to='/form/checkout'
                                className={payment_recap.unselectable}
                                ref={checkout_cta}
                            >
                                <div className={`cta ${payment_recap.cta}`} ref={total_button_txt}>
                                    Configurer mon prélèvement SEPA →
                                </div>
                            </Link>

                            <div className={payment_recap.security}>
                                <img alt="icon lock" src="/icon/lock.svg" /> Paiement sécurisé
                            </div>

                            {/* <div className={payment_recap.reinsurance}>
                                <div className={payment_recap.important}>🎁 15 jours offerts</div>
                            </div> */}
                        </div>

                        <div className={payment_recap.contact}>
                            <div className={payment_recap.title}>Une question sur votre commande ?</div>
                            <div className={payment_recap.description}>Contactez notre équipe disponible de 9h à 19h.</div>
                            <div className={payment_recap.telephone}>
                                <div className={payment_recap.number}>
                                    <img className={`${payment_recap.icon} ${payment_recap.telephone}`} alt="icon telephone" src="/icon/telephone.svg" />
                                    {' '}
                                    <Link to="tel:+33745898101">07 45 89 81 01</Link>
                                </div>
                                <div className={payment_recap.free}>Gratuit</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="actions">
                    <Link to='/gestion/packs'><div className="prev"><div className="arrow"></div>Retour</div></Link>
                    <div className="next" style={{ display: 'none' }}>Continuer</div>
                </div>
            </div>
        </div>
    );
}

export default GestionMerchantRecap;
